module.exports = __webpack_public_path__ + "media/images/swifticons/pulse-icon-9b0a81152aaf9c78775fc2a7f9b44306.svg";